u<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Pré Fatura Receita</h4>
              <span
                >Insira todos os dados nos filtros para obter os
                resultados</span
              >
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inativar Registros"
                      v-if="getPermission('unidade.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive" style="min-height: 400px">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="table-responsive">
                  <b-col md="6" offset-md="6">
                    <b-row no-gutters>
                      <b-col class="p-0">
                        <!-- <AvisoErros v-bind:errors_array="errors_array"></AvisoErros> -->
                        <div class="loadingData" v-if="loadingDataStore">
                          <div class="loadingDataSpinner">
                            <spinner
                              v-if="loadingDataStore"
                              text-fg-color="#ffffff"
                              message="Carregando..."
                            ></spinner>
                          </div>
                        </div>
                      </b-col>
                      <b-col class="p-0">
                        <label>Vlr. total nfs</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_nfs"
                          placeholder="Vlr. total nfs"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: 'R$ ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-button
                        @click="onStore()"
                        style="height: 40px; place-self: end"
                        >Associar</b-button
                      >
                    </b-row>
                  </b-col>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('gerarprefaturareceita.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/gerarprefaturareceita"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="doc_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="unidade-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="cliente" slot-scope="props">
                      <span>{{
                        props.rowData.doc_cte_partes_env.tom_nome
                      }}</span>
                    </template>
                    <template slot="dt_emi" slot-scope="props">
                      <!-- <span>{{ this.formatDate(props.rowData.dt_emi) }}</span> -->
                      <span>{{ formatDate(props.rowData.dt_emi) }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <!-- <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-if="getPermission('unidade.update')" v-b-tooltip title="Editar"><i class="fa fa-edit"></i></a>
                                                <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                <a @click="onCreateDoc(props.rowData, props.rowIndex)"  v-if="getPermission('unidade.documento.store')" v-b-tooltip title="Vincular Documento"><i class="fa fa-file"></i></a>
                                                <a @click="onCreateConta(props.rowData, props.rowIndex)"  v-if="getPermission('unidade.conta.store')" v-b-tooltip title="Vincular Conta"><i class="fa fa-money"></i></a>
                                                <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            </div>
                                          </template> -->
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import PreFaturaReceitaFilterBarVue from "./PreFaturaReceitaFilterBar.vue";

// Vue.component('unidade-detalhes', UnidadeDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": PreFaturaReceitaFilterBarVue,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      dados: [],
      dataExport: [],
      clienteOptions: [],
      tpDocOptions: [],
      loadingDataStore: false,
      isLoadingCliente: false,
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      filter_data_store: {},
      filtros_form: new Form({
        cliente: "",
        dt_emissao_ini: "",
        dt_emissao_fim: "",
        tp_doc: "",
      }),
      form: new Form({ vlr_total_nfs: 0, vlr_total_nfs2: 0, docs: [] }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:cliente",
          title: "Cliente",
          sortField: "cliente",
        },
        {
          name: "num_fiscal",
          title: "N° Fiscal",
          sortField: "num_fiscal",
        },
        {
          name: "serie",
          title: "Série",
          sortField: "serie",
        },
        {
          name: "__slot:dt_emi",
          title: "Data Emissão",
          sortField: "dt_emi",
        },
        {
          name: "tp_doc.descr",
          title: "Tipo de Documento",
          sortField: "tp_doc.descr",
        },
        {
          name: "vlr_receber",
          title: "Valor",
          sortField: "vlr_receber",
        },
        //   {
        //       name: '__slot:actions',   // <----
        //       title: 'Ações',
        //       titleClass: 'center aligned',
        //       dataClass: 'center aligned'
        //   }
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      // if(this.$refs.vuetable.selectedTo.length > 0){
      //    this.$refs.vuetable.selectedTo = [];
      // }
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.cliente = this.filter_data_store.cliente;
          this.filtros_form.dt_emissao_ini =
            this.filter_data_store.dt_emissao_ini;
          this.filtros_form.dt_emissao_fim =
            this.filter_data_store.dt_emissao_fim;
          this.filtros_form.tp_doc = this.filter_data_store.tp_doc;
          this.filtros_form
            .post("/api/gerarprefaturareceita/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj.doc_id));
                this.form.vlr_total_nfs += obj.vlr_receber;
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.form.vlr_total_nfs = 0;
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.$refs.vuetable.selectedTo = null;
      this.$refs.vuetable.selectedTo = [];
      this.moreParams = {
        cliente: data_filter.cliente.value,
        dt_emissao_ini: data_filter.dt_emissao_ini,
        dt_emissao_fim: data_filter.dt_emissao_fim,
        tp_doc: data_filter.tp_doc.value,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = null;
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      if (this.$refs.vuetable.tableData != null) {
        this.dataExport.push(this.$refs.vuetable.tableData);
        this.dataExport.forEach((obj2) => {
          obj2.forEach((obj3) => {
            this.dados.push({
              doc_id: obj3.doc_id,
              vlr_total_nfs: obj3.vlr_receber,
            });
          });
        });
      }

      this.$watch(
        () => {
          return this.$refs.vuetable.selectedTo;
        },
        (obj) => {
          this.somaValoresNfs(obj);
        }
      );
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    somaValoresNfs(obj) {
      this.form.vlr_total_nfs2 = 0;
      obj.forEach((item, i) => {
        this.data = this.dados.filter((item2) => item2.doc_id === item);
        this.form.vlr_total_nfs2 =
          parseFloat(this.data[0].vlr_total_nfs) + this.form.vlr_total_nfs2;
      });
      if (this.$refs.vuetable.selectedTo.length == 0) {
        this.form.vlr_total_nfs = 0;
      }
      if (this.form.vlr_total_nfs2 != 0) {
        this.form.vlr_total_nfs = this.form.vlr_total_nfs2;
      }
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.unidade_id);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onCreate() {
      this.$refs.unidadeform.onCreate();
    },
    onEdit(data, index) {
      this.$refs.unidadeform.onEdit(data);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.docs = [];

      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form.docs.push({ doc_id: obj });
      });
      this.form
        .put("/api/gerarprefaturareceita/store")
        .then((response) => {
          new ReturnApi(response, this);
          Vue.nextTick(() => this.$refs.vuetable.refresh());
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.loadingDataStore = false;
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/gerarprefaturareceita/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);

          response.cliente.forEach((obj) => {
            this.clienteOptions.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
          response.tp_doc.forEach((obj) => {
            this.tpDocOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>
